import * as Sentry from "@sentry/react";
import * as React from "react";
import { 
  createRoutesFromChildren, 
  matchRoutes, 
  useLocation,
  useNavigationType
} from "react-router-dom";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN || " ",
  
  // Enable console logs to be sent to Sentry
  enableLogs: true,
  
  // Enable sending user data like IP and headers for better debugging
  sendDefaultPii: true,
  
  integrations: [
    // Console logging integration to capture all console logs
    Sentry.consoleLoggingIntegration({
      levels: ["log", "info", "warn", "error", "debug"]
    }),
    
    // Performance monitoring for navigation events with React Router v6
    Sentry.browserTracingIntegration(),
    
    // React Router v6 integration for better navigation tracking
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    
    // Session replay for debugging user interactions (especially useful for video calls)
    Sentry.replayIntegration({
      // Mask sensitive data in replays
      maskAllText: false,
      maskAllInputs: true,
      blockAllMedia: false,
    }),
    
  ],
  
  // Performance monitoring - capture 10% of transactions in production
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.1,
  
  // Track performance for your API endpoints
  tracePropagationTargets: [
    /^\//, 
    /^https:\/\/.*\.supabase\.co\//, 
    /^https:\/\/.*\.livekit\.cloud\//
  ],
  
  // Session replay settings
  replaysSessionSampleRate: import.meta.env.DEV ? 1.0 : 0.1, // 100% in dev, 10% in prod
  replaysOnErrorSampleRate: 1.0, // Always capture replay when there's an error
  
  // Environment detection
  environment: import.meta.env.DEV ? "development" : "production",
  
  // Release tracking (you can set this via CI/CD)
  release: import.meta.env.VITE_APP_VERSION || "unknown",
  
  // Filter out noisy errors
  beforeSend(event) {
    // Filter out extension-related errors
    if (event.exception?.values?.[0]?.value?.includes('Extension context invalidated')) {
      return null;
    }
    
    // Filter out network errors that might be expected in voice calls
    if (event.exception?.values?.[0]?.type === 'NetworkError' && 
        event.exception?.values?.[0]?.value?.includes('WebRTC')) {
      return null;
    }
    
    return event;
  },
});